const styles = {
  animatedWrapperBaseSx: {
    px: { xs: 2.5, sm: 3, md: 0 },
    transition: "opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s",
  },

  layoutRowSx: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: 3, md: 5 },
    alignItems: "flex-start",
  },

  imagePanelSx: {
    position: "relative",
    width: { xs: "100%", md: "45%" },
    maxWidth: { md: "460px" },
    flexShrink: 0,
    display: { xs: "flex", md: "block" },
    justifyContent: { xs: "center", md: "unset" },
    py: { xs: "20px", md: 0 },
    backgroundColor: { xs: "rgba(255,255,255,0.03)", md: "transparent" },
    border: { xs: "1px solid rgba(255,255,255,0.06)", md: "none" },
    overflow: "hidden",
  },

  xArrowsOverlaySx: {
    display: { xs: "block", md: "none" },
    position: "absolute",
    inset: 0,
    zIndex: 1,
    pointerEvents: "none",
  },

  featuredSidebarSx: {
    display: { xs: "flex", md: "none" },
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "5.5%",
    alignItems: "center",
    justifyContent: "center",
    borderRight: "1px solid rgba(255,255,255,0.1)",
    clipPath: "polygon(0% 0%, 100% 5.5%, 100% 94.5%, 0% 100%)",
    zIndex: 2,
  },

  featuredLabelSx: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    fontSize: "7px",
    letterSpacing: "0.22em",
    color: "rgba(255,255,255,0.28)",
    fontWeight: 700,
    userSelect: "none",
    textTransform: "uppercase",
  },

  eventImageSx: {
    width: { xs: "auto", md: "100%" },
    maxWidth: { xs: "65%", md: "100%" },
    maxHeight: { xs: "400px", md: "none" },
    height: "auto",
    display: "block",
    borderRadius: "8px",
    backgroundColor: "#1a1a1a",
    position: "relative",
    zIndex: 1,
  },

  detailsBoxSx: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  featuredChipSx: {
    display: { xs: "none", md: "flex" },
    mb: 2,
    backgroundColor: "#2a2a2a",
    color: "#aaa",
    letterSpacing: "0.1em",
    fontSize: "11px",
    fontWeight: 600,
  },

  dateRowSx: { display: "flex", alignItems: "center", mb: 1 },

  locationRowSx: { display: "flex", alignItems: "center", mb: { xs: 2, md: 2 } },

  genresRowSx: { display: "flex", flexWrap: "wrap", gap: 1, mb: 2.5 },

  descriptionSx: {
    mb: 3,
    lineHeight: 1.8,
    fontSize: { xs: "0.875rem", md: "0.925rem" },
    color: "#c7c7c7",
    display: "-webkit-box",
    WebkitLineClamp: { xs: 4, md: 6 },
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },

  buttonRowSx: { display: "flex", gap: 2, width: "100%" },

  dateLabelSx: { ml: 1.5, fontSize: { xs: "0.82rem", md: "1rem" }, color: "#c7c7c7" },

  titleSx: {
    fontWeight: "bold",
    fontSize: { xs: "1.4rem", md: "2.5rem" },
    lineHeight: 1.2,
    mb: { xs: 1.5, md: 2.5 },
  },

  viewDetailsButtonSx: { flex: 1, height: { xs: 52, md: 48 }, fontSize: { xs: 13, md: 15 } },
};

export default styles;
